import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMatch } from 'react-router-dom';
import { Label } from '@localina/core';
import { Page } from '../../components';
import { ErrorCode, Path } from '../../enums';

interface IPathParams {
    errorCode: string;
}

const Error: React.FC = () => {
    const { t } = useTranslation();
    const params = useMatch(Path.ERROR)?.params as IPathParams;
    const { errorCode } = params;

    const getErrorMessage = () => {
        switch (+errorCode) {
            case ErrorCode.MISSING_QUERY_PARAMS:
                return t('error.messages.missingQueryParams');
            case ErrorCode.RESTAURANT_NOT_FOUND:
                return t('error.messages.restaurantNotFound');
            default:
                return '';
        }
    };

    return (
        <Page name="error">
            <Label type="title" value={t('error.title')} variant="h5" />
            <Label type="text" value={getErrorMessage()} />
        </Page>
    );
};

export default Error;
